import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';
import { colors } from 'themes/components';
import styled from 'styled-components';

import { osName } from 'react-device-detect';

import { mt } from 'styled-components-spacing';
import Button, { ButtonStyles } from 'components/Button';

const Wrapper = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  /* ${mt(1)} */
  border-radius: 16px;
  & > *:first-child {
    margin-right: 12px;
  }
`;

const IconButton = styled.a`
  ${ButtonStyles}
  display: inline-flex;
  align-items: center;
  & > svg {
    margin-right: 8px;
    transition: fill 0.2s ease;
  }
  &:hover > svg,
  &:focus > svg {
    fill: ${colors.grey90};
  }
`;

const HeroCta = ({ primaryCta }) => {
  const [os, setOs] = useState('');

  useEffect(() => {
    setOs(osName);
  }, []);

  const MacView = ({ children }) => {
    if (os === 'Mac OS') {
      return children;
    }
    return null;
  };

  const WinView = ({ children }) => {
    if (os === 'Windows') {
      return children;
    }
    return null;
  };

  const SignUpButton = ({ children }) => {
    if (os === 'Mac OS' || os === 'Windows') {
      return null;
    }
    return children;
  };

  return (
    <Wrapper>
      {/*{os === 'Windows' && (
        <WinView>
          <IconButton
            download
            href="https://mudstack-desktop.s3.amazonaws.com/mudstack_windows_latest.exe"
          >
            <WindowsIcon fillColor={colors.teal40} />
            Download for Windows
          </IconButton>
        </WinView>
      )}
       {os === 'Mac OS' && (
        <MacView>
          <IconButton
            download
            href="https://mudstack-desktop.s3.amazonaws.com/mudstack_mac_latest.dmg"
          >
            <MacOSIcon fillColor={colors.teal40} />
            Download for Mac
          </IconButton>
        </MacView>
      )}
      {os !== 'Windows' && os !== 'Mac OS' && (
        <SignUpButton>
          <Button as="a" href="https://app.mudstack.com/signup" rel="nofollow">
            Sign up free
          </Button>
        </SignUpButton>
      )} */}
      <Button as={Link} large to="/get-a-demo">
        Get a demo
      </Button>
      {/* <Button
        as={Link}
        large
        secondary
        to="/desktop"
        dangerouslySetInnerHTML={{
          __html: primaryCta ? primaryCta : `Get started free &rarr;`
        }}
      ></Button> */}
    </Wrapper>
  );
};

export default HeroCta;
